import {
    changeCaseForTranslatable,
    joinTranslatables,
} from "../translations/text-utils";
import type { Translatable } from "../translations/translation";
import { translation } from "../translations/translation";

const getProperNameFromContactInfo = (
    contactInfo:
        | {
              firstName?: string | null | undefined;
              lastName?: string | null | undefined;
              name?: string | null | undefined;
          }
        | undefined
        | null,
): Translatable => {
    if (!contactInfo) return "";
    const firstName = contactInfo?.firstName?.trim();
    const lastName = contactInfo?.lastName?.trim();
    // const name = contactInfo?.name?.trim();
    // if (!firstName && !lastName && !!name) return name;
    return changeCaseForTranslatable(
        joinTranslatables([
            firstName ??
                translation({
                    sv: "Anonym kund",
                    en: "Anonymous customer",
                }),
            " ",
            lastName ?? "",
        ]),
        "capitalCase",
    );
};

export { getProperNameFromContactInfo };
